import { BaseContainerModel } from '../../../base-container.model';
import { bl_del_trip_driver_link_RowClass } from '../../../../dbschema';

export class TripDriverLinkContainerModel extends BaseContainerModel {
    bl_del_trip_driver_link: bl_del_trip_driver_link_RowClass = new bl_del_trip_driver_link_RowClass();
}